import { meshComponent } from './Mesh.js';
import { props, createGeometry } from '../geometries/SphereGeometry.js';

export default meshComponent('Sphere', props, createGeometry);
